import { render, staticRenderFns } from "./icon-legend-info.vue?vue&type=template&id=cad41c70&"
import script from "./icon-legend-info.vue?vue&type=script&lang=js&"
export * from "./icon-legend-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports